import React from 'react';

/**
 * Last-refreshed badge — STUB.
 *
 * The backend has no refresh-status endpoint yet (known gap,
 * .kiro/steering/tech.md). Polling a nonexistent endpoint produced a wall of
 * 500s, so the badge renders nothing until the endpoint ships.
 *
 * TODO(backend refresh-status): add accessors/GetRefreshStatusApi + an RTK
 * endpoint, render `Last refreshed: <timestamp>`, and include lastRefreshedAt
 * in the getMetrics query arg so the cache key rotates on backend refresh
 * (see metricsApi.ts cache notes).
 */
export const RefreshStatusBadge: React.FC = () => null;
